import React, { useState, useEffect, useRef } from 'react';
import ProjectCard from './ProjectCard';
import Button from '../common/Button';
import Icon from '../common/Icon';
import './ProjectsList.css';

const ProjectsList = ({ projects, onCreateProject, onRetrySuccess, onCancelSuccess, folders = [], studyFolderMap = {}, onFolderChange, onSearch, searchTerm: externalSearchTerm, totalCount, showHeader = false }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState(externalSearchTerm || '');
    const debounceRef = useRef(null);

    useEffect(() => {
        setLocalSearchTerm(externalSearchTerm || '');
    }, [externalSearchTerm]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setLocalSearchTerm(value);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            if (onSearch) onSearch(value);
        }, 300);
    };

    const handleClearSearch = () => {
        setLocalSearchTerm('');
        if (onSearch) onSearch('');
    };

    const displayCount = totalCount !== undefined ? totalCount : (projects?.length || 0);

    return (
        <section className="projects-list">
            {showHeader && (
                <>
                    <div className="projects-header">
                        <h2 className="section-title">Projets récents</h2>
                        {onCreateProject && (
                            <Button
                                variant="primary"
                                onClick={onCreateProject}
                                icon={<Icon name="Plus" size={18} />}
                            >
                                Nouveau projet
                            </Button>
                        )}
                    </div>
                    <div className="projects-search">
                        <div className="search-input-wrapper">
                            <Icon name="Search" size={18} color="var(--color-gray-400)" />
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Rechercher par domaine..."
                                value={localSearchTerm}
                                onChange={handleSearchChange}
                            />
                            {localSearchTerm && (
                                <button className="search-clear" onClick={handleClearSearch} aria-label="Effacer la recherche">
                                    <Icon name="X" size={16} />
                                </button>
                            )}
                        </div>
                        <p className="search-results">{displayCount} projet{displayCount > 1 ? 's' : ''}</p>
                    </div>
                </>
            )}

            {projects && projects.length > 0 ? (
                <div className="projects-grid">
                    {projects.map((project) => (
                        <ProjectCard
                            key={project.studyId}
                            project={project}
                            onRetrySuccess={onRetrySuccess}
                            onCancelSuccess={onCancelSuccess}
                            folders={folders}
                            currentFolderId={studyFolderMap[project.studyId] || null}
                            onFolderChange={onFolderChange}
                        />
                    ))}
                </div>
            ) : (
                <div className="projects-empty">
                    <Icon name="Folder" size={64} color="var(--color-gray-300)" />
                    <p className="empty-title">Aucun projet pour le moment</p>
                    <p className="empty-subtitle">
                        Créez votre premier projet pour commencer à analyser votre SEO
                    </p>
                    {onCreateProject && (
                        <Button variant="primary" onClick={onCreateProject} icon={<Icon name="Plus" size={18} />}>
                            Créer un projet
                        </Button>
                    )}
                </div>
            )}
        </section>
    );
};

export default ProjectsList;
